module.exports = __webpack_public_path__ + "media/assets/icons/chevron-right-4b36ebabe4958d214d1eb42028fa80d2.png";